import React from "react";
import "./_club-description.scss";
import {ignoredInclusions} from "../../../constants/Config";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/configureStore";
import {InclusionType} from "../../../types/ApiTypeDefinition/singleClubFinderResultTypes";

interface ClubDescriptionPropTypes {
  clubFormatObject: any
  clubDescription: string
  inclusions?: any
}

const ClubDescription = (props: ClubDescriptionPropTypes): JSX.Element => {
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);
  const competitionFormatsList = (props.clubFormatObject && props.clubFormatObject.length > 0) ?  props.clubFormatObject.map((formatText: any, index: number) =>
    <div className={'formatContainer'} key={index}>
      <div className={'formatText'}>
        {formatText?.formatName}
      </div>
    </div>
  ) : null;

  const formattedInclusionItems = props.inclusions ? props.inclusions.filter((item: InclusionType) => !ignoredInclusions[tenant].includes(item.inclusionPlayHQValue)) : null;

  const inclusionList = (formattedInclusionItems && formattedInclusionItems.length > 0) ?  formattedInclusionItems.map((inclusionItem: any, index: number) =>
    <div className={'formatContainer'} key={index}>
      <div className={'formatText'}>
        {inclusionItem?.inclusionDisplayValue}
      </div>
    </div>
  ) : null;

  return (
    <div className={'clubDescriptionContainer'}>
      {props.clubDescription && (
        <div className={'clubDescriptionText'}>
          {props.clubDescription}
        </div>
      )}

      {(props.clubFormatObject && props.clubFormatObject.length > 0) && (
        <div className={'formatHeading'}>
          Competitions/Programs we offer
        </div>
      )}
      <div className={'formatList'}>
        {competitionFormatsList}
      </div>

      {(formattedInclusionItems && formattedInclusionItems.length > 0) && (
        <div className={'formatHeading'}>
          Inclusion Programs
        </div>
      )}
      <div className={'formatList inclusion-programme-list'}>
        {inclusionList}
      </div>
    </div>
  )
}

export default ClubDescription;
